import { Corner, IStackedElement, StackedElementsService } from '../services/StackedElementsService';

export class Popup {

  private getPositionElement: () => JQuery;
  private getContentElement: () => JQuery;
  private stackedElementsService: StackedElementsService;
  private stackedElement: IStackedElement;

  constructor(
      getPositionElement: () => JQuery,
      getContentElement: () => JQuery,
      stackedElementsService: StackedElementsService
  ) {
    this.getPositionElement = getPositionElement;
    this.getContentElement = getContentElement;
    this.stackedElementsService = stackedElementsService;
  }

  public show(positionCorner: Corner, contentCorner: Corner) {
    this.stackedElement = this.stackedElementsService.createStackedElement(
      positionCorner, this.getPositionElement(), contentCorner, this.getContentElement());
  }

  public hide() {
    this.stackedElementsService.removeStackedElement(this.stackedElement);
  }

}
